// ================================================================
// Platform Assistant Chats API — Auswertung aller Assistenten-Gespräche
// (nur Plattform-Rollen, Recht platform:assistant:read)
// ================================================================
import { apiRequest } from './apiClient.js';

// filters: { days, orgId, userId, kind, only, q, limit }
export function listAssistantChats(filters = {}) {
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== '' && v !== null && v !== undefined) qs.set(k, String(v));
  }
  const suffix = qs.toString() ? '?' + qs.toString() : '';
  return apiRequest('/api/platform/assistant-chats' + suffix);
}

export function getAssistantChat(id) {
  return apiRequest('/api/platform/assistant-chats/' + encodeURIComponent(id));
}
